import { render } from "./Input.vue?vue&type=template&id=6236e917"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
script.render = render

export default script